<template>
  <div class="mb-8 w-full">
    <div class="flex items-center">
      <div class="flex flex-col">
        <p class="text-dark-blue">
          {{ subject }}
        </p>
        <p
          v-if="factorName && showFactorName"
          class="w-full py-2 font-bold text-dark-blue"
        >
          Factoring Company: {{ factorName }}
        </p>
      </div>
      <slot />
    </div>
    <p class="mb-1 text-xxs font-bold uppercase text-gray-over-dark">
      {{ question.description }}
    </p>
    <div
      v-if="customOptions?.length > 0"
      class="mt-4 grid grid-cols-2 gap-2"
    >
      <div
        v-for="option in customOptions"
        :key="option"
        class="mb-2 w-full md:mb-0"
      >
        <round-radio-button
          custom-class="text-xs sm:text-sm"
          :item="option"
          :value="option"
          :name="'radio_' + question_id"
          :checked="option === selection"
          :handle-click="handleClick"
        />
      </div>
    </div>
    <div
      v-else
      class="mt-4 grid grid-cols-2 gap-2"
    >
      <div class="force-inline-flex loading-gradient col-span-1 rounded-md">
        <div
          class="block w-full rounded-full p-6 text-center text-sm text-placeholder-gray"
        >
          Loading answer options...
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RoundRadioButton from '@/components/RoundRadioButton.vue';
import _ from 'lodash';

export default {
  name: 'Radio',
  components: {
    RoundRadioButton,
  },
  props: {
    question: Object,
    question_id: Number,
    subject: String,
    setOnboardingPacket: Function,
    toggleRequired: Function,
    required: Boolean,
    conditional_children: Array,
  },
  emits: ['child-check'],
  data() {
    return {
      selection: '',
    };
  },
  computed: {
    customOptions() {
      return this.$store.state.onboardingPacket?.factor_office_options;
    },
    orderedOptions() {
      return _.orderBy(this.question.options, 'order');
    },
    stepName() {
      return this.$store.state.formRoutes?.activeStepIdentifier;
    },
    factorName() {
      return this.$store.state.carriers.carrierData?.factor?.name;
    },
    showFactorName() {
      return this.question?.is_type == 'jb_hunt_factor_offices';
    },
  },
  // created() {
  //   let recentAnswer = this.question?.most_recent_previous_answer;
  //   if (recentAnswer) {
  //     this.selection = recentAnswer.answer_options[0].option_id;
  //     this.handleAutoInput();
  //   }
  // },
  watch: {
    '$store.state.onboardingPacket.current_stage': {
      handler: function (val) {
        let self = this;
        if (val == 7 && self.selection !== '') {
          self.emitForComparison(self.selection);
        }
      },
      immediate: true,
      deep: true,
    },
    stepName: {
      handler(newVal) {
        if (newVal == 'Questions') {
          let recentAnswer = this.question?.most_recent_previous_answer;
          if (recentAnswer) {
            this.selection = recentAnswer.string_value;
            this.handleAutoInput();
          }
        }
      },
      immediate: true,
    },
  },
  created() {
    this.$store.dispatch('onboardingPacket/getFactorOfficeOptions');
  },
  methods: {
    handleClick(e) {
      this.selection = e.target.value;
      let body = {
        company_question_id: this.question_id,
        string_value: this.selection,
      };

      this.setOnboardingPacket(body);
      if (this.required) {
        this.selection
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(this.selection);
    },
    handleAutoInput() {
      let body = null;
      if (this.selection) {
        body = {
          company_question_id: this.question_id,
          string_value: this.selection,
        };
      }

      this.setOnboardingPacket(body);
      if (this.required) {
        this.selection
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(this.selection);
    },
    emitForComparison(value) {
      if (this.conditional_children?.length > 0) {
        this.conditional_children.forEach((child) => {
          if (
            child?.evaluation_js?.length > 0 &&
            child?.company_question_id > 0
          ) {
            this.$emit(
              'child-check',
              child.company_question_id,
              value,
              child.evaluation_js,
              child.is_shown_by_default,
              child.is_required
            );
          }
        });
      }
    },
  },
};
</script>
